/* @ngInject */
const pieceService = (
  pieceAsk,
  pieceFormat,
  pieceGo,
  pieceLocal,
  pieceMetadata,
  pieceRequest
) => {
  const self = {}

  self.ask = pieceAsk
  self.format = pieceFormat
  self.go = pieceGo
  self.local = pieceLocal
  self.metadata = pieceMetadata
  self.request = pieceRequest
  self.data = {}

  self.new = () => {
    return {
      name: null,
      quantity: null,
      sendingDate: null,
      sendingPlace: null,
    }
  }

  return self
}
export default pieceService



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/piece.service.js